import React from 'react';

// GLOBAL VARIABLES
import { NUMBER_FORMATS } from 'numberFormats.js';

export default function Placeholder() {
  return <span className="text-gray-600">{NUMBER_FORMATS.date.placeholder}</span>;
}
